import { Shield, Lock, Eye, FileCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const privacyFeatures = [
  {
    icon: Lock,
    title: "Ephemeral Processing",
    description: "AI processing is short-lived and not retained after the operation completes. All data is deleted immediately after extraction.",
  },
  {
    icon: Shield,
    title: "Direct to Microsoft",
    description: "Contacts are created or updated directly in your Outlook account via the Microsoft Graph API. We do not store your contact data.",
  },
  {
    icon: Eye,
    title: "Full Transparency",
    description: "You see every extracted field before saving. Optional features like Smart Categories and Smart Notes work on contact metadata you approve.",
  },
  {
    icon: FileCheck,
    title: "EU-Friendly Processing",
    description: "AI processing uses EU-based servers with zero data retention. Designed with GDPR principles and Privacy by Design.",
  },
];

export const Privacy = () => {
  return (
    <section className="py-24 bg-gradient-privacy">
      <div className="container px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-foreground/10 backdrop-blur-sm border border-secondary-foreground/20 mb-6">
            <Shield className="w-4 h-4 text-secondary-foreground" />
            <span className="text-sm font-medium text-secondary-foreground">Privacy by Design</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-secondary-foreground">
            Privacy-First. Built for GDPR.
          </h2>
          <p className="text-xl text-secondary-foreground/80 max-w-2xl mx-auto">
            All AI processing happens in EU data centers with zero data retention. You control what gets processed.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {privacyFeatures.map((feature, index) => (
            <div 
              key={index}
              className="bg-secondary-foreground/5 backdrop-blur-sm rounded-2xl p-8 border border-secondary-foreground/10"
            >
              <div className="mb-6 inline-flex p-4 rounded-xl bg-secondary-foreground/10">
                <feature.icon className="w-8 h-8 text-secondary-foreground" />
              </div>
              
              <h3 className="text-2xl font-bold mb-3 text-secondary-foreground">
                {feature.title}
              </h3>
              
              <p className="text-secondary-foreground/80 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-secondary-foreground/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-secondary-foreground/20 max-w-4xl mx-auto text-center">
          <h3 className="text-3xl font-bold mb-4 text-secondary-foreground">
            100% Auditable & AppSource-Ready
          </h3>
          <p className="text-lg text-secondary-foreground/80 mb-6 max-w-2xl mx-auto">
            Email2Contact uses secure, EU-based AI processing (ConvertAPI EU, Azure OpenAI West Europe) with zero data retention. All processing is ephemeral, built with GDPR principles, and can be independently audited.
          </p>
          <Button variant="privacy" size="lg" className="text-lg">
            <FileCheck className="w-5 h-5" />
            Learn about our privacy standards
          </Button>
        </div>
      </div>
    </section>
  );
};
